// extracted by mini-css-extract-plugin
export var box = "services-module--box--09b11";
export var btn = "services-module--btn--04cf0";
export var service = "services-module--service--bc270";
export var serviceBox = "services-module--serviceBox--97468";